import { render, staticRenderFns } from "./three-column-table.vue?vue&type=template&id=24c0beb8&"
import script from "./three-column-table.vue?vue&type=script&lang=js&"
export * from "./three-column-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports